import { api } from "./client";

// Host edits of live markers. savedAt is the save time the admin was shown: when the host
// saved again since, the backend refuses the decision with 409.
export const HostEditsAPI = {
  list: async () => {
    const { data } = await api.get("/api/admin/host-edits");
    return Array.isArray(data) ? data : [];
  },

  /** Approves the marker, which merges the edit into it. */
  apply: async (markerId, savedAt) => {
    await api.post(`/api/admin/host-edits/${markerId}/apply`, null, { params: { savedAt } });
  },

  discard: async (markerId, savedAt) => {
    await api.delete(`/api/admin/host-edits/${markerId}`, { params: { savedAt } });
  },
};
